<template>
  <div>
    <base-header class="pb-6 content__title content__title--calendar">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-dark d-inline-block mb-0">{{ $route.name }}</h6>
          <!-- <router-link to="/">
          <i class="fas fa-home"></i>
        </router-link> -->
          <router-link :to="'/leadsListings' + '?page=' + listing_current_page" class="text-primary">
            <b-icon icon="chevron-left"></b-icon>
            Leads Profile
          </router-link>
          <!-- <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav> -->
        </div>
        <div class="col-lg-6 mt-3 mt-lg-0 text-lg-right">
          <a
            href="#"
            @click.prevent="prev"
            class="fullcalendar-btn-prev btn btn-sm btn-default"
          >
            <i class="fas fa-angle-left"></i>
          </a>
          <a
            href="#"
            @click.prevent="next"
            class="fullcalendar-btn-next btn btn-sm btn-default"
          >
            <i class="fas fa-angle-right"></i>
          </a>
          <base-button
            class="btn btn-sm btn-default"
            @click="changeView('dayGridMonth')"
          >
            Month
          </base-button>
          <base-button
            class="btn btn-sm btn-default"
            @click="changeView('dayGridWeek')"
          >
            Week
          </base-button>
          <base-button
            class="btn btn-sm btn-default"
            @click="changeView('timeGridDay')"
          >
            Day
          </base-button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <!-- Fullcalendar -->
          <div class="card card-calendar">
            <!-- Card header -->
            <div class="card-header">
              <!-- Title -->
              <h5 class="h3 mb-0">Calendar</h5>
            </div>
            <!-- Card body -->
            <div class="card-body p-0 card-calendar-body">
              <div id="fullCalendar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          name="title"
          label="Event title"
          placeholder="Event Title"
          v-model="model.title"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>
        <div class="form-group">
          <label class="form-control-label d-block mb-3">Status color</label>
          <div class="btn-group btn-group-toggle btn-group-colors event-tag">
            <label
              v-for="color in eventColors"
              :key="color"
              class="btn"
              :class="[color, { 'active focused': model.className === color }]"
            >
              <input
                v-model="model.className"
                type="radio"
                name="event-tag"
                :value="color"
                autocomplete="off"
              />
            </label>
          </div>
        </div>
        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template v-slot:footer>
        <button
          type="submit"
          class="btn btn-primary new-event--add"
          @click="saveEvent"
        >
          Add event
        </button>
        <button
          type="button"
          class="btn btn-link ml-auto"
          @click="showAddModal = false"
        >
          Close
        </button>
      </template>
    </modal> -->

      <modal :show.sync="showEditModal" modal-classes="modal-secondary">
    <h3>{{ model.title }}</h3>
    <p><strong>Agent Assigned:</strong> {{ model.agent_name }}</p>
    <p><strong>Contact No:</strong> {{ model.contact_no }}</p>
    <p><strong>Email:</strong>  {{ model.email }}</p>
    <p><strong>Income:</strong>  {{ model.income }}</p>
    <p><strong>Current Address:</strong>  {{ model.current_address }}</p>
    <p><strong>Customer:</strong>  {{ model.customer }}</p>
    <p><strong>Main Status:</strong>  {{ model.main_status }}</p>
    <p><strong>Sub Status:</strong>  {{ model.sub_status }}</p>

    </modal>

  </div>
</template>
<script>
import Modal from "@/components/Modal";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridDay from "@fullcalendar/timegrid";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";

import {
  notifyFunctionMixin,
  axios,
  services,
  getHeader,
  debounce,
} from "@/assets/js/httpImports.js";
const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();
var calendar;
export default {
  name: "calendar",
  components: {
    // RouteBreadCrumb,
    Modal,
  },
  data() {
    return {
      event: [],
      listing_current_page: 1, 
      model: {
        title: "New event",
        className: "bg-default",
        description:
          "Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        start: "",
        end: "",
      },
      showAddModal: false,
      showEditModal: false,
      eventColors: [
        "bg-info",
        "bg-orange",
        "bg-red",
        "bg-green",
        "bg-default",
        "bg-blue",
        "bg-purple",
        "bg-yellow",
      ],
    };
  },
  methods: {
    initCalendar() {
      var calendarEl = document.getElementById("fullCalendar");

      calendar = new Calendar(calendarEl, {
        plugins: [dayGridPlugin, timeGridDay, interactionPlugin],
        selectable: true,
        headerToolbar: false,
        select: () => {
          this.showAddModal = true;
          this.model.start = new Date(y, m, 21);
          this.model.end = new Date(y, m, 21);
        },
        eventClick: (info) => {
          const leadId = info.event._def.publicId;
          this.getLead(leadId);

          // this.model = {
          //   title: leadData.name,
          //   className: "bg-green", // Set the appropriate class or use leadData.status to determine
          //   start: leadData.appointment_at,
          //   end: leadData.appointment_at,
          //   description: leadData.name,
          //   id: leadData.lead_id, // Assuming lead_id is the lead ID
          //   contact_no: leadData.contact_no,
          //   email: leadData.email,
          //   current_address: leadData.current_address || "N/A", // Use a default value if current_address is null
          //   // Add more properties as needed
          // };

          // this.showEditModal = true;
        },
        events: this.events,
      });
      calendar.render();
    },
    changeView(newView) {
      calendar.changeView(newView);
      calendar.view.title;
    },
    next() {
      calendar.next();
    },
    prev() {
      calendar.prev();
    },
    saveEvent() {
      if (this.model.title) {
        let event = {
          ...this.model,
          allDay: true,
        };
        this.events.push(JSON.parse(JSON.stringify(event)));
        // console.log(this.events);
        this.model = {
          title: "",
          eventColor: "bg-danger",
          start: "",
          end: "",
        };
      }
      this.showAddModal = false;
    },
    editEvent() {
      let index = this.events.findIndex((e) => e.title === this.model.title);
      if (index !== -1) {
        this.events.splice(index, 1, this.model);
      }
      this.showEditModal = false;
    },
    deleteEvent() {
      let index = this.events.findIndex((e) => e.title === this.model.title);
      if (index !== -1) {
        this.events.splice(index, 1);
      }
      this.showEditModal = false;
    },
     getLead(id)
     {
        axios.get(services.lead + 'leads/' + id, {
          headers: getHeader(),
        })
        .then((res) => {
          const leadData = res.data.data
            //  console.log(leadData);
            const mainStatus = leadData.status_detail && leadData.status_detail.main ? leadData.status_detail.main.status : "N/A";
            const subStatus = leadData.status_detail && leadData.status_detail.sub ? leadData.status_detail.sub.status : "N/A";

            this.model = {
              title: leadData.name,
              agent_name: leadData.assign_detail.name,
              className: "bg-green", 
              start: leadData.appointment_at,
              end: leadData.appointment_at,
              description: leadData.name,
              id: leadData.lead_id,
              contact_no: leadData.contact_no !== null ? leadData.contact_no : "N/A",
              email: leadData.email !== null ? leadData.email : "N/A",
              current_address: leadData.current_address !== null ? leadData.current_address : "N/A",
              customer: leadData.customer !== null && leadData.customer.name !== null ? leadData.customer.name : "N/A",
              income: leadData.income !== null ? leadData.income : "N/A",
              main_status: mainStatus,
              sub_status: subStatus,
            };
            // Open the edit modal
            this.showEditModal = true;
          })
        .catch((e) => {
          if (typeof this.errorFunction === 'function') {
            this.errorFunction(e);
          } else {
            console.error("An error occurred, but errorFunction is not defined or is not a function:", e);
          }
        });
      },
  },
  mounted() {
    axios.get(services.lead + "lead/leadscalendar", {
      headers: getHeader(),
    })
    .then((res) => {
      const leadsData = res.data.data;
      if (typeof leadsData === 'object' && leadsData !== null) {
        const leadsArray = Object.values(leadsData);
        this.events = leadsArray.map((lead) => {
            // Get the last log in the appointment_status_history
            const agentName = lead.assignToDetails ? lead.assignToDetails.name : '';
            const agentInitials = _gHlp.formatInitials(agentName)
          
            let className = "bg-green";

            const titleWithInitials = `(${agentInitials}) ${lead.lead_name} `;
            return {
                title: titleWithInitials,
                start: lead.appointment_at,
                end: lead.appointment_at,
                className: className,
                description: lead.lead_name,
                id: lead['lead-id'] || null,
            }
        });
        } else {
            console.error("leadsData is not an object or is null:", leadsData);
            this.events = [];
        }
        this.initCalendar();
    })
    .catch((e) => {
        if (typeof this.errorFunction === 'function') {
            this.errorFunction(e);
        } else {
            console.error("An error occurred, but errorFunction is not defined:", e);
        }
    });
  },
};
</script>
<style lang="scss">
@import "~@/assets/sass/core/vendors/fullcalendar";
</style>


